import { canSeeInfraFunds } from './access';

// Single source of truth for the sidebar navigation: Sidebar renders it, the admin "Menü anpassen" dialog lists it.
// access (item overrides group): all | non_ac | admin | ac | infra (non-AC with Infra-Fonds level) |
// timeclock (only while a weekly target is set) | team_dev_ac (AC member explicitly granted Team Development).
// `standalone` groups render as a bare link (no accordion). `locked` items can never be hidden by an admin.
export const MENU_GROUPS = [
  { id: 'activity', label: 'Activity', standalone: true, items: [
    { id: 'activity', label: 'Activity', to: '/activity', testid: 'nav-activity', access: 'all' },
  ] },
  { id: 'my-tabs', label: 'My ♥ Tabs', standalone: true, items: [
    { id: 'my-tabs', label: 'My ♥ Tabs', to: '', testid: 'nav-my-tabs', access: 'all', hint: 'automatisch: meistgenutzte Seiten' },
  ] },
  { id: 'pipeline', label: 'Pipeline', items: [
    { id: 'funnel', label: 'Deal Funnel', to: '/', end: true, testid: 'nav-funnel', access: 'all' },
    { id: 'explorer', label: 'Deal Explorer', to: '/explorer', testid: 'nav-explorer', access: 'non_ac' },
    { id: 'thesis-screening', label: 'KI Deal Screening', to: '/thesis-screening', testid: 'nav-thesis-screening', access: 'admin' },
    { id: 'compare', label: 'Compare Deals', to: '/compare', testid: 'nav-compare', access: 'non_ac' },
  ] },
  { id: 'broker', label: 'Broker', access: 'non_ac', items: [
    { id: 'deal-inbox', label: 'Deal Inbox', to: '/deal-inbox', testid: 'nav-deal-inbox' },
    { id: 'broker-traffic', label: 'Broker Mails', to: '/broker-traffic', testid: 'nav-broker-traffic' },
    { id: 'broker-calls', label: 'Broker-Gespräche', to: '/broker-calls', testid: 'nav-broker-calls' },
    { id: 'broker-campaigns', label: 'Broker Campaigns', to: '/broker-campaigns', testid: 'nav-campaigns' },
    { id: 'broker-stats', label: 'Broker-Statistik', to: '/broker-stats', testid: 'nav-broker-stats' },
  ] },
  { id: 'my-work', label: 'My Work', items: [
    { id: 'my-reviews', label: 'My Reviews', to: '/reviews', testid: 'nav-my-reviews', access: 'non_ac' },
    { id: 'mentions', label: 'Mentions', to: '/mentions', testid: 'nav-mentions', access: 'non_ac' },
    { id: 'tasks', label: 'My Tasks', to: '/tasks', testid: 'nav-tasks', access: 'non_ac' },
    { id: 'my-time', label: 'My Time', to: '/my-time', testid: 'nav-my-time', access: 'timeclock', hint: 'nur bei gesetztem Wochenziel' },
    { id: 'favorites', label: 'My Favorites', to: '/favorites', testid: 'nav-favorites', access: 'all' },
    { id: 'bookmarks', label: 'My Bookmarks', to: '/bookmarks', testid: 'nav-bookmarks', access: 'all' },
    { id: 'settings', label: 'My Settings', to: '/settings', testid: 'nav-settings', access: 'all', locked: true },
  ] },
  { id: 'team', label: 'Team', access: 'non_ac', items: [
    { id: 'meeting', label: 'Team Meeting', to: '/meeting', testid: 'nav-meeting' },
    { id: 'ac-meeting', label: 'AC Meeting', to: '/ac-meeting', testid: 'nav-ac-meeting' },
    { id: 'whos-turn', label: "Who's Turn?", to: '/whos-turn', testid: 'nav-whos-turn' },
    { id: 'team-development', label: 'Team Development', to: '/team-development', testid: 'nav-team-development' },
    { id: 'reviews', label: 'Pending Reviews', to: '/reviews', testid: 'nav-reviews' },
  ] },
  { id: 'outreach', label: 'Outreach', access: 'non_ac', items: [
    { id: 'contacts', label: 'Contacts', to: '/contacts', testid: 'nav-contacts' },
    { id: 'outreach', label: 'Outreach', to: '/outreach', testid: 'nav-outreach' },
    { id: 'outreach-sequences', label: 'Sequences', to: '/outreach-sequences', testid: 'nav-outreach-sequences' },
    { id: 'ab-live', label: 'A/B Testing', to: '/ab-live', testid: 'nav-ab-live' },
    { id: 'post', label: 'Post', to: '/post', testid: 'nav-post' },
    { id: 'approval-workplace', label: 'iAuto Workspace', to: '/approval-workplace', testid: 'nav-approval-workplace', access: 'admin' },
  ] },
  { id: 'insights', label: 'Insights', items: [
    { id: 'health', label: 'Pipeline Health', to: '/health', testid: 'nav-pipeline-health', access: 'non_ac' },
    { id: 'team-kpis', label: 'KPIs', to: '/team-kpis', testid: 'nav-team-kpis', access: 'all' },
    { id: 'calls', label: 'Call Analytics', to: '/calls', testid: 'nav-calls', access: 'non_ac' },
    { id: 'infra-funds', label: 'Infra-Fonds', to: '/infra-funds', testid: 'nav-infra-funds', access: 'infra' },
    { id: 'outreach-stats', label: 'Outreach Statistics', to: '/outreach-stats', testid: 'nav-outreach-stats', access: 'all' },
    { id: 'ab-live', label: 'A/B Testing', to: '/ab-live', testid: 'nav-ab-live', access: 'ac' },
    { id: 'team-analytics', label: 'Team Analytics', to: '/team-analytics', testid: 'nav-team-analytics', access: 'admin' },
  ] },
  { id: 'guides', label: 'Guides', access: 'non_ac', items: [
    { id: 'manual', label: 'Handbuch', to: '/manual', testid: 'nav-manual' },
    { id: 'outreach-guide', label: 'Outreach Guide', to: '/outreach-guide', testid: 'nav-outreach-guide' },
    { id: 'feedback-guide', label: 'Feedback Guide', to: '/feedback-guide', testid: 'nav-feedback-guide' },
  ] },
  { id: 'finance', label: 'Finance', access: 'non_ac', items: [
    { id: 'budget', label: 'Budget Tracker', to: '/budget', testid: 'nav-budget' },
    { id: 'reporting', label: 'Investor Reports', to: '/reporting', testid: 'nav-reporting', access: 'admin' },
  ] },
  { id: 'admin', label: 'Admin', access: 'admin', items: [
    { id: 'team', label: 'Team & Roles', to: '/team', testid: 'nav-team' },
    { id: 'system', label: 'System', to: '/system', testid: 'nav-system' },
    { id: 'vestaboard', label: 'Vestaboard', to: '/vestaboard', testid: 'nav-vestaboard' },
    { id: 'ai-costs', label: 'KI-Kosten', to: '/ai-costs', testid: 'nav-ai-costs' },
    { id: 'sectors', label: 'Sectors', to: '/sectors', testid: 'nav-sectors' },
    { id: 'scorecard-info', label: 'Scorecard Info', to: '/scorecard-info', testid: 'nav-scorecard-info' },
  ] },
  { id: 'team-ac', label: 'Team', standalone: true, access: 'team_dev_ac', items: [
    { id: 'team-development', label: 'Team Development', to: '/team-development', testid: 'nav-team-development-ac' },
  ] },
];

export const itemAccess = (item, group) => item.access || group.access || 'all';

// ctx.timeclockEnabled: live value in the sidebar; the admin dialog passes true (the entry only shows once a target is set).
export function roleAllows(access, user, ctx = {}) {
  const role = user?.role || 'analyst';
  const isAc = role === 'ac_member';
  switch (access) {
    case 'all': return true;
    case 'non_ac': return !isAc;
    case 'admin': return role === 'admin';
    case 'ac': return isAc;
    case 'infra': return !isAc && canSeeInfraFunds(user);
    case 'timeclock': return !!ctx.timeclockEnabled;
    case 'team_dev_ac': return isAc && !!user?.team_dev_access;
    default: return false;
  }
}

// Groups + items the user's ROLE allows (before per-user hiding). Admins are never restricted.
export function groupsForUser(user, ctx = {}) {
  return MENU_GROUPS.map(g => ({ ...g, items: g.items.filter(it => roleAllows(itemAccess(it, g), user, ctx)) }))
    .filter(g => g.items.length > 0);
}

export const hiddenSetFor = (user) => new Set(user?.role === 'admin' ? [] : (user?.hidden_menu_items || []));

// All real page items (deduped by id) — used to map a pathname back to a menu item for "My ♥ Tabs".
export const MENU_ITEMS = (() => {
  const seen = new Map();
  MENU_GROUPS.forEach(g => g.items.forEach(it => { if (it.to && !seen.has(it.id)) seen.set(it.id, { ...it, groupId: g.id }); }));
  return [...seen.values()];
})();

export const menuItemForPath = (pathname) => {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  if (p === '/') return MENU_ITEMS.find(it => it.to === '/') || null;
  let best = null;
  MENU_ITEMS.forEach(it => {
    if (it.to !== '/' && (p === it.to || p.startsWith(it.to + '/')) && (!best || it.to.length > best.to.length)) best = it;
  });
  return best;
};
